import { CustomStatusPanelProps } from 'ag-grid-react';
import { t } from 'i18next';
import { sum } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import { ComponentStatus } from 'bom/enums';
import { TotalPrice } from 'core/elements';
import { useAgGridClientTableContext } from 'core/states';
import { IJobPart } from 'jobs/types';

interface IProps extends CustomStatusPanelProps {
  totalLabel: string;
}

export const TotalsStatusBar = ({ totalLabel = t('labelTotal') }: IProps) => {
  const [totals, setTotalPrices] = useState<{ cost: number | undefined }>({
    cost: undefined,
  });

  const classNames = 'ag-status-name-value ag-status-panel';

  const { rows } = useAgGridClientTableContext();

  const calculateTotalCost = useCallback((records: IJobPart[]) => {
    const activeRecordList = records.filter((record) => record.status !== ComponentStatus.DELETED);

    const cost =
      sum(activeRecordList.map((record) => record.quantity * record.computedCost)) || undefined;

    setTotalPrices({ cost });
  }, []);

  useEffect(() => {
    calculateTotalCost(rows as IJobPart[]);
  }, [calculateTotalCost, rows]);

  return <TotalPrice label={totalLabel} value={totals?.cost} options={{ classNames }} />;
};
